module.exports = __webpack_public_path__ + "static/media/img-nodefect.f614df96.png";